module.exports = __webpack_public_path__ + "assets/img/组 534@2x.734e3e75.png";